const isProd = process.env.NODE_ENV === 'production';

const logger = {
  error: (...args) => console.error('[StraightConnect]', ...args),
  warn: (...args) => console.warn('[StraightConnect]', ...args),
  info: (...args) => { if (!isProd) console.log('[StraightConnect]', ...args); },
  debug: (...args) => { if (!isProd) console.log('[StraightConnect:debug]', ...args); },
};

export default logger;
